var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"items":_vm.items,"label":_vm.label,"rules":_vm.required ? [_vm.requiredRule] : []},on:{"change":_vm.change},model:{value:(_vm.title),callback:function ($$v) {_vm.title=$$v},expression:"title"}})}
var staticRenderFns = []

export { render, staticRenderFns }